define('views/profile/profile',[
	'backbone',
	'views/_base/baseview',
	'text!views/profile/profile.html',
	'views/profile/profile_content',
	'views/profile/password',
	'views/linkedaccounts/linkedaccounts',
	'views/notifications/dashboard',
	'views/reservations/reservations',
	'views/profile/invite',
	'views/contact/contact',
	'views/delete-account/delete-account',
	'models/invite/campaign',
	'views/invite/invitationlist',
	'views/invite/invite',
	'views/terms/term_links',
	'views/howto/howto',
	'views/shared/modal/modal_modern'
], function(Backbone, BaseView, Template, ProfileView, PasswordView, LinkedAccountsView, NotificationDashboardView, ReservationsView, InviteView, ContactView, DeleteAccountView, CampaignModel, InvitationList, InviteModalView, TermLinksView, HowToView, Modal){
	'use strict';

	return BaseView.extend({
		id       : 'profile-container',
		tagName  : 'div',
		isRender : true,
		needsAuth: false,
		template : _.template(Template),
		events   : {
			'click .profile-list-item' : 'handleProfileNavigation',
			'click .js-profile-mobile-back': 'toggleMenuAndContent',
			'click .js-profile-logout' : 'signOut'
		},
		initialize: function(options){
			options = options || {};
			
			this.options = (options.options) ? options.options : {};
			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
		},

		render: function(){
			var that = this;

			if(pf.IsConsumerFinancial){

				var wellness = pf.getFeature(enums.features.wellness);

				if(_.isObject(wellness)){
					
					var status_id = pf.session.get('UserStatusId');

					if(status_id != undefined){

						if((status_id & enums.userStatusId.accepted_cardholder_agreement) != enums.userStatusId.accepted_cardholder_agreement){
							pf.controller.showAddressConfirmation();

							return false;
						}

					}

				}

				this.$el.html(this.template());

				this.addProfileLinks();

				this.populateProfile();

				this.checkInviteEligibility();

			} else {

				if(this.options.view == 'contact' || this.options.view == 'terms' || this.options.view == 'delete-account'){

					this.$el.html(this.template());

					this.addProfileLinks();

					this.populateProfile();

					if(this.options.view != 'terms'){

						this.checkInviteEligibility();

					}

				} else {
					
					goToFinancialRegistration(this.options.view);

				}
				
			}
			

			return this;
		},

		loadData: function(){},

		addProfileLinks: function(){

			var that = this,
				links = pf.getContent('routes.profile.links');

			if(_.isArray(links)){

				links.forEach(function(link){

					var item = document.createElement('li'),
						inner_item = document.createElement('a');

					if(link.class){
						inner_item.setAttribute('class', link.class);
					}

					if(link.id){
						inner_item.setAttribute('id', link.id);
					}

					if(link.external){
						inner_item.setAttribute('target', '_blank');
					}

					inner_item.setAttribute('href', link.url);

					inner_item.innerHTML = link.text;

					item.appendChild(inner_item);

					that.$('.js-profile-links').append(item);

				});

			}

		},

		populateProfile: function(){
			var that = this;

			this.updateProfileNavigation();

			this.updateNavigationHeader();

			switch(this.options.view){
				case 'profile':
					this.showProfile();
					break;
				case 'password':
					this.showChangePassword();
					break;
				case 'linkedaccounts':
					this.showLinkedAccounts();
					break;
				case 'notifications':
					this.showNotificationDashboard();
					break;
				case 'reservations':
					this.showReservations();
					break;
				case 'invite':
					
					this.checkInviteEligibility(function(valid){
						
						if(valid){
							that.showInvite();
						} else {
							// TODO: Add visual for ineligible user
						}
						
					});

					break;
				case 'contact':
					this.showContact();
					break;
				case 'delete-account':
					this.showDeleteAccount();
					break;
				case 'terms':
					this.showTerms();
					break;
				case 'how-to':
					this.showHowTo();
					break;
				default:
					this.showProfile();
					break;
			}

		},

		handleProfileNavigation: function(e){
			if(e && e.preventDefault){ e.preventDefault(); }
			if(e && e.stopPropagation){ e.stopPropagation(); }

			var window_width = $(window).width(),
				href = $(e.target).attr('href').slice(1);

			if(window_width < 768 && href != 'terms'){
				this.options.view = href;

				this.populateProfile();

				this.toggleMenuAndContent();
			} else {

				// If the link is an external link then open in new window
				if($(e.target).attr('target') == '_blank'){
					window.open($(e.target).attr('href'))
				} else {
					pf.navigate(href);
				}
				
			}
			
		},

		toggleMenuAndContent: function(){
			this.$('.js-profile-list').toggle();
			this.$('.js-profile-content-container').toggle();
			this.$('.js-profile-navigation-header').toggle();
			this.$('.js-profile-main-header').toggle();
		},

		updateNavigationHeader: function(){
			var header_name = '';

			switch(this.options.view){
				case 'profile':
					header_name = 'Profile';
					break;
				case 'password':
					header_name = 'Change Password';
					break;
				case 'linkedaccounts':
					header_name = 'Linked Accounts';
					break;
				case 'invite':
					header_name = 'Invite Friends & Family';
					break;
				case 'contact':
					header_name = 'Contact Us';
					break;
				case 'delete-account':
					header_name = 'Delete My Account';
					break;
				case 'terms':
					header_name = 'Terms';
					break;
				default:
					header_name = 'Profile';
					break;
			}

			this.$('.js-profile-navigation-header-name').html(header_name);
		},

		updateProfileNavigation: function(){
			this.$('#profile-list').find('.profile-list-item').removeClass('active');
			this.$('#profile-list').find('.profile-list-item[href*=#' + this.options.view + ']').addClass('active');
		},

		showProfile: function(){
			var profile_view = new ProfileView({ elementName: '#profile-content-container' });
		},

		showChangePassword: function(){
			var password_view = new PasswordView({ elementName: '#profile-content-container' });
		},

		showLinkedAccounts: function(){
			var linkedaccounts_view = new LinkedAccountsView({ elementName: '#profile-content-container' });
		},

		showNotificationDashboard: function(){
			var notification_dashboard_view = new NotificationDashboardView({ elementName: '#profile-content-container' });
		},

		showReservations: function(){
			var reservations_view = new ReservationsView({ elementName: '#profile-content-container' });
			// var contact_view = new ContactView({ elementName: '#profile-content-container' });
		},

		showContact: function(){
			var contact_view = new ContactView({ elementName: '#profile-content-container' });
		},

		showDeleteAccount: function(){
			var contact_view = new DeleteAccountView({ elementName: '#profile-content-container' });
		},

		showInvite: function(){
			var invite_view = new InviteView({ elementName: '#profile-content-container' });
		},

		showTerms: function(){
			var term_links_view = new TermLinksView({ elementName: '#profile-content-container', options: this.options });
		},

		showHowTo: function(){
			var how_to_view = new HowToView({ elementName: '#profile-content-container', options: this.options });
		},

		updateData: function(){
			this.render();

			if(pf.session.get('auth')){
				this.checkInviteEligibility();
			}
			
		},

		checkInviteEligibility: function(callback){
			var that = this,
				wellness = pf.getFeature(enums.features.wellness);
			
			if(!wellness){

				this.invite_model = new CampaignModel();
				this.invite_model.fetch({
					success: function(model, resp){
						var data = that.invite_model.toJSON();
						
						if(data.CanInvite){

							$('.js-friends-family').css({ display: 'block' });
							
							if(_.isFunction(callback)){
								callback(true);
							}

						} else {
							if(_.isFunction(callback)){
								callback(true);
							}
						}

					},
					error: function(){}
				});

			}
			
		},

		profileInvitations: function(e){
			if(e && e.preventDefault){ e.preventDefault(); }
			if(e && e.stopPropagation){ e.stopPropagation(); }

			this.$("#profile_subnav a").removeClass("active");
			this.$("#profile_invitations").addClass("active");

			this.invitationListView = new InvitationList({ UGID: this.ID });
			this.loadView(this.invitationListView, ".content");
			return this;
		},

		// showFfForm: function(e){
		//     if(e && e.preventDefault){ e.preventDefault(); }
		//     if(e && e.stopPropagation){ e.stopPropagation(); }

		//     // Show Friends & Family Form within a modal
		//     var invite_view = new InviteView(),
		//         modal = new Modal({
		//             show        : true, // True, if we want the modal to show itself when it's ready
		//             title       : 'Invite Friends & Family',
		//             content     : invite_view.$el.html(),
		//             calling_view: invite_view // Send in corresponding view to inherit events and custom properties
		//         });
		// },

		signOut: function(e){
			if(e && e.preventDefault){ e.preventDefault(); }
			if(e && e.stopPropagation){ e.stopPropagation(); }

			pf.controller.signOut();
		},

		close: function(){}
	});
});

